import * as ActionName from '../action-names';

export default {
  updateBreadcrumbsFromRoute: function(details){
    return { type: ActionName.UPDATE_BREADCRUMBS_FROM_ROUTE, details };
  }
};
